import { useApolloClient } from './api/config';
import RootNavigator from './navigators/RootNavigator';

function App() {
    const apolloClient = useApolloClient();
    return <RootNavigator {...{ apolloClient }} />;
}

export default App;
